export default __webpack_public_path__ + "static/media/osm.73e2758e.png";